import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { currentLang, setLang } from "../lib/i18n";

export function LangToggle() {
  const { t } = useTranslation();
  const lang = currentLang();
  const next = lang === "th" ? "en" : "th";
  const label = `${t("lang.toggle")}: ${t("lang." + next)}`;
  return (
    <button type="button" className="btn-icon" aria-label={label} title={label} onClick={() => void setLang(next)}>
      <Languages size={18} aria-hidden />
      <span className="sr-only">{lang.toUpperCase()}</span>
    </button>
  );
}
